import Menu from '../components/menu';

export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    var DOM = {};

    DOM.grim = document.querySelector('.grim');
    DOM.menu = new Menu(DOM.grim);

    DOM.menu.open();
  },
}



// WEBPACK FOOTER //
// ./scripts/routes/fruts.js